const footerMenu = [
    {
        footerMenu1 : {
            title:"Company",
            menu:[{label:"About Reachello",value:"/about-us"},{label:"Contact Us",value:"/contact-us"}]
        },
        footerMenu2 : {
            title:"Other",
            menu:[{label:"Terms & Conditions",value:"/terms-conditions"},{label:"Privacy Policy",value:"/privacy-policy"},{label:"Advertising Policy",value:"/"}],
        }
    }
]

export default footerMenu;